module.exports = __webpack_public_path__ + "static/media/speech_23.3c559c27.svg";